import { DynamicInputModel, serializable, DynamicFormControlLayout, DynamicInputModelConfig, MATCH_VISIBLE } from '@ng-dynamic-forms/core';
import { BLUETOOTH_PRINTER_CODE_COMPONENT, BluetoothPrinterItem } from '../bluetooth-printer-designer.models';

export enum BT_SEPARATOR_STYLE {
	LINE = 'LINE',
	DOTTED = 'DOTTED',
}

export interface BtHSeparatorModelConfig extends DynamicInputModelConfig {
	separatorStyle: BT_SEPARATOR_STYLE;
}

export class BtHSeparatorModel extends DynamicInputModel {
	@serializable() override readonly type: string = 'bt_h_separator'; 
	separatorStyle: BT_SEPARATOR_STYLE;

	constructor(config: BtHSeparatorModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.separatorStyle = config.separatorStyle;
	}

	static initModel(_component: BluetoothPrinterItem): BtHSeparatorModel { 
		const formModel = new BtHSeparatorModel({
			id: _component.ID!,
			name: _component.ID,
			label: '',//_component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE,
			separatorStyle: _component.TEXT_STYLE as BT_SEPARATOR_STYLE,
			additional: _component
		});
		return formModel;
	}

	static getProperties() {
        return {
            CODE: BLUETOOTH_PRINTER_CODE_COMPONENT.H_SEPARATOR,
            NAME: 'Separateur Horizontal',
            ICON: 'remove-outline',
            PROPERTIES: [
                { ID: 'TYPE_COMPONENT', CODE: BLUETOOTH_PRINTER_CODE_COMPONENT.TEXTBOX, LABEL: 'Type', DEFAULT_VALUE: 'Séparateur Horizontal', IS_READONLY: true },
                { ID: 'INDEX', CODE: BLUETOOTH_PRINTER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index' },
                { ID: 'DEFAULT_VALUE', CODE: BLUETOOTH_PRINTER_CODE_COMPONENT.TEXTBOX, LABEL: 'Valeur', DEFAULT_VALUE: 'Label' },
                { ID: 'SEPARATOR_STYLE', CODE: BLUETOOTH_PRINTER_CODE_COMPONENT.DROPDOWN, LABEL: 'Style', DS_DATAS: [
                    { ID: 'LINE', VALUE: 'Ligne' },
                    { ID: 'DOTTED', VALUE: 'Tirets' },
                ], DS_VALUE_COLUMN_NAME: 'ID', DS_DISPLAY_COLUMN_NAME: 'VALUE', DEFAULT_VALUE: 'LINE' },
            ]
        };
    }
}